export const SETUP_RESTAURANT_PATH = '/setup/restaurant';

export function getOwnerHomePath(restaurants) {
    if (!restaurants || restaurants.length === 0) {
        return SETUP_RESTAURANT_PATH;
    }
    return '/restaurants';
}
